import {Injectable} from '@angular/core';

import {HttpRepository} from './http.repository';
import {GlobalConfig} from '../configs/GlobalConfig';
import {AlertComment} from "../interfaces/rest/AlertComment";
import {Observable} from "rxjs";


@Injectable()
export class AlertCommentRepository {

  private acknowledgeAlertEndpoint: string = GlobalConfig.dataApiEndpoints.alertData + '/AcknowledgeActiveAlert';

  constructor(protected httpRepository: HttpRepository) {

    }


    saveAlertComment(alertComment: AlertComment) {
      return this.httpRepository.post(GlobalConfig.dataApiEndpoints.alertData + '/comments', alertComment);

    }

    getAlertComments(alertInstanceId: string, alertRuleId: string): Observable<Array<AlertComment>> {
      return this.httpRepository.get(`${GlobalConfig.dataApiEndpoints.alertData}/comments?alertInstanceId=${alertInstanceId}&alertRuleId=${alertRuleId}`);

    }

  acknowledgeAlert(acknowledgePayload: string) {
    return this.httpRepository.post(this.acknowledgeAlertEndpoint, acknowledgePayload);
  }


}
